import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_BILL_DATA_CONFIGURATION = "GET_BILL_DATA_CONFIGURATION";

export const service = async () => {
  const options: object = {
    url: `/Api/BillDataConfiguration/GetBillDataConfiguration`,
    method: "GET",
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_BILL_DATA_CONFIGURATION, service, mock);
